// extracted by mini-css-extract-plugin
export default {"TotalSupplyLabel":"TotalSupply_TotalSupplyLabel__pbo44","mintProgress":"TotalSupply_mintProgress__glg5a","mintProgressSupply":"TotalSupply_mintProgressSupply__PXFcB"};